import React, { useEffect } from 'react';
import { VerticalSpacer } from '@01_people/ui-library';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PersonalForm } from '../components/profile/personal';
import { ProfileSC, FormSection } from './profile.styled';
import ChangeEmailProcess from '../components/profile/change-email-process';
import ChangePhoneNumberProcess from '../components/profile/change-phone-number-process';
import * as ActionCreators from '../redux/action';

const Profile = ({ fetchUserData, fetchKycStatus, user }) => {
  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  useEffect(() => {
    fetchKycStatus();
  }, [fetchKycStatus]);

  return (
    <div className="container">
      <ProfileSC>
        <FormSection id="profile-info">
          {!user ? null : (
            <>
              <PersonalForm customFields />
              <VerticalSpacer height="2px" customClass="form-spacer" />
              <ChangeEmailProcess />
              <VerticalSpacer height="2px" customClass="form-spacer" />
              <ChangePhoneNumberProcess />
            </>
          )}
        </FormSection>
      </ProfileSC>
    </div>
  );
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchUserData: ActionCreators.fetchUserData,
      fetchKycStatus: ActionCreators.fetchKycStatusRequest
    },
    dispatch
  );

export default connect(
  state => ({ user: state.user }),
  mapDispatchToProps
)(Profile);
